import React from "react";
import { Link } from "react-router-dom";
import "./AirplaneMode.css";

/** Shared frame for the Airplane Mode Games pages: room-gradient
 *  background, wordmark linking home to the family page, one pixel-
 *  chrome panel for the content, and the contact footer. */
export default function AmgPage({ title, effective, children }) {
  return (
    <div className="amg">
      <div className="amg-inner">
        <Link to="/airplane-mode-games" className="amg-wordmark">
          <span className="amg-wordmark-top">AIRPLANE MODE</span>
          <span className="amg-wordmark-main">GAMES</span>
        </Link>
        <main className="amg-panel">
          <h1>{title}</h1>
          {effective && <p className="amg-effective">{effective}</p>}
          {children}
        </main>
        <footer className="amg-footer">
          <span className="amg-suit">♠</span>
          <a href="mailto:help@testco.de">help@testco.de</a>
          <span className="amg-suit">♠</span>
        </footer>
      </div>
    </div>
  );
}
